import styled from 'styled-components';

export const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow-y: auto;
	text-align: center;
	width: 100%;
`;

export const ModalStep = styled.p`
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 0.05em;
	line-height: 12px;
	text-align: center;
	text-decoration-skip-ink: none;
`;

export const ModalTitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
	margin: 0 0 32px;
`;

export const ModalDescription = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	margin: 0 0 8px;
`;
export const ContainerButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	margin-top: 32px;
`;

export const ContainerButton = styled.div`
	width: 50%;
`;

interface ButtonProps {
	variant: 'pure' | 'abell';
}

export const Button = styled.button<ButtonProps>`
	background: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.abell) ||
		(variant === 'pure' && theme.colors.principal.pure)};
	border: ${({ theme, variant }) =>
		(variant === 'abell' && 'none') ||
		(variant === 'pure' && `1px solid ${theme.colors.principal.ceres}`)};
	border-radius: 8px;
	color: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.pure) ||
		(variant === 'pure' && theme.colors.principal.vanth)};
	cursor: pointer;
	padding: 15px 14px;
	width: 100%;

	&:hover {
		opacity: 0.7;
	}

	&:disabled {
		cursor: default;
		opacity: 0.2;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const ContainerForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const InputValidation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin: 0;
	padding: 0;
`;

export const TextError = styled.label`
	color: ${({ theme }) => theme.colors.extra.sword};
	font-size: 12px;
	font-weight: 400;
	line-height: 13.2px;
	text-align: left;
`;

export const ContainerSwitch = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	height: 26px;
	justify-content: space-between;
`;

export const QuestLabel = styled.p`
	font-size: 16px;
	font-weight: 400;
	letter-spacing: -0.0008em;
	line-height: 28px;
	text-align: left;
`;
